import { Document } from "../../"

export interface Flags extends Document {
  [key: string]: any
}
